export function reduceOpacity(hexadecimal: string, reductionFactor: number) {
  if (!hexadecimal.startsWith('#')) {
    hexadecimal = `#${hexadecimal}`;
  }

  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hexadecimal.slice(i, i + 2), 16));

  reductionFactor = Math.max(0, Math.min(1, reductionFactor));

  const newOpacity = Math.round(255 * (1 - reductionFactor));

  return `#${[r, g, b, newOpacity].map((c) => c.toString(16).padStart(2, '0')).join('')}`;
}
